module.exports = __webpack_public_path__ + "img/Veritas_island_raw.16da5491.png";